import React, { useEffect } from 'react';

const icons = {
  success: (
    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  ),
  error: (
    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  info: (
    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01" />
    </svg>
  ),
  warning: (
    <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M4.93 19h14.14a2 2 0 001.74-2.99l-7.07-12.25a2 2 0 00-3.48 0L3.19 16.01A2 2 0 004.93 19z" />
    </svg>
  ),
};

const styles = {
  success: 'bg-green-50 text-green-900 border-green-400',
  approve: 'bg-green-50 text-green-900 border-green-400',
  error: 'bg-red-50 text-red-900 border-red-400',
  reject: 'bg-red-50 text-red-900 border-red-400',
  info: 'bg-blue-50 text-blue-900 border-blue-400',
  warning: 'bg-yellow-50 text-yellow-900 border-yellow-400',
};

export default function Notifier({
  type = 'info',
  message = '',
  show = false,
  onClose,
  duration = 3000,
}) {
  useEffect(() => {
    if (show && duration && onClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show || !message) return null;

  return (
    <div
      className={`fixed top-20 left-1/2 transform -translate-x-1/2 flex items-center gap-3 px-6 py-3 rounded-full shadow-lg border-2 font-semibold text-base ${styles[type] || styles.info}`}
      style={{ fontFamily: 'Inter, sans-serif', minWidth: 320, justifyContent: 'center', zIndex: 100000 }}
    >
      <span className="flex items-center justify-center">
        {icons[type] || icons.info}
      </span>
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          className="ml-2 p-1 rounded-full hover:bg-gray-200 focus:outline-none"
          aria-label="Close notification"
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}
